var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-view",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.WhyGamefoundLink },
      }),
      _vm._v(" "),
      _c("base-hero", {
        attrs: {
          title: "Why Gamefound?",
          description:
            "From funding to fulfillment, Gamefound gives you powerful tools, expert insights, and a passionate community — so your campaign can go further.",
          type: "whyGamefound",
        },
      }),
      _vm._v(" "),
      _c(
        "base-container",
        { staticClass: "_flexcol _gap-6 _py-6", attrs: { width: "narrow" } },
        [
          _c(
            "box",
            { staticClass: "_flexcol _gap-6", attrs: { huge: "" } },
            [
              _c("div", { staticClass: "_tac" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h2" }, [
                  _vm._v(_vm._s(_vm.ecoSystem.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
                  _vm._v(_vm._s(_vm.ecoSystem.subtitle)),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.ecoSystem.items, function (item) {
                return _c(
                  "div",
                  { key: item.icon, staticClass: "_flex _gap-3" },
                  [
                    _c(
                      "div",
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: {
                            name: item.icon,
                            "icon-namespace": item.iconNameSpace,
                            "is-fixed-width": "",
                            "has-base-class": "",
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "gfu-bt gfu-bt--b1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.text) +
                          "\n                    "
                      ),
                      item.url
                        ? _c(
                            "a",
                            {
                              staticClass: "gfu-link gfu-link--accent",
                              attrs: {
                                href: item.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        learn more\n                        "
                              ),
                              _c("base-icon", {
                                attrs: { name: "chevron-right", size: "sm" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.goOnBoard.author,
              quote: _vm.quotes.goOnBoard.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Want more details? We're happy to share!"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                Gamefound supports creators of all sizes - whether you're just starting out or already a major\n                player.\n                Here are just a few examples from different segments:\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("why-gamefound-project-explorer", {
            attrs: { "project-tags": _vm.projectTags },
          }),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.gabeBarrett.author,
              quote: _vm.quotes.gabeBarrett.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Feature comparison"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                Features that set Gamefound apart from the competition.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("platform-feature-comparison"),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.creativeGameStudio.author,
              quote: _vm.quotes.creativeGameStudio.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Beyond the obvious"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                How Gamefound actually works for you.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "box",
            {
              staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6",
              attrs: { huge: "" },
            },
            [
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("Even 49% better results on Gamefound"),
                ]),
                _vm._v(
                  "\n                Features like Follower Gifts, Stretch Pay, Endgame, and multiple payment methods can significantly\n                boost your campaign’s performance — sometimes without you even realizing it. "
                ),
                _c("br"),
                _vm._v(
                  "\n                This is the kind of extra lift you might not have known was possible.\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: { src: "/content/images/static/why-gf/perks.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: {
                      src: "/content/images/static/why-gf/reprints.svg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("Reprints earn 93% more on Gamefound"),
                ]),
                _vm._v(
                  "\n                Creators often see significant gains on Gamefound when reprinting titles originally launched on Kickstarter.\n                With powerful conversion tools and an engaged community, your next run can outperform your first.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("There’s 65% more to come after crowdfunding"),
                ]),
                _vm._v(
                  "\n                On average, creators raise an additional 65% during the Late Pledge and Pledge Manager phases. With\n                Gamefound, your campaign keeps growing even after the main funding ends.\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: { src: "/content/images/static/why-gf/tree.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: {
                      src: "/content/images/static/why-gf/popup-promo.svg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c _gap-1" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
                  _vm._v(
                    "Adfound - the elite marketing tool built into Gamefound"
                  ),
                ]),
                _vm._v(
                  "\n                Reach the right backers at the right time. Adfound supports flexible ad budgeting and tracks\n                performance from pre-launch to post-campaign — helping you grow followers, boost sales, and get more\n                from every ad dollar.\n                "
                ),
                _c(
                  "div",
                  { staticClass: "_pt-1" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: {
                          theme: "accent",
                          tag: "a",
                          href: _vm.performanceMarketingUrl,
                        },
                      },
                      [_vm._v("Learn more")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c _gap-1" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
                  _vm._v("Advanced pledge manager with a proven track record"),
                ]),
                _vm._v(
                  "\n                The pledge manager on Gamefound has been developed since 2016 and is continuously being improved\n                to accommodate all the needs of crowdfunding. It has helped over 1,000 creators deliver more than\n                2,400 projects worth hundreds of millions of dollars.\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: { src: "/content/images/static/why-gf/pm.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "_col-span-2--l _tac" }, [
                _c("h4", { staticClass: "gfu-hd gfu--h3" }, [
                  _vm._v(
                    "Thanks to Gamefound's features, your campaign can reach its full\n                    potential."
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.chipTheoryGames.author,
              quote: _vm.quotes.chipTheoryGames.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Growth in numbers"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                A breakdown of our core indicators, year over year - and they speak volumes.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" },
            [
              _c("themed-image", {
                attrs: { src: "/content/images/static/why-gf/users-graph.svg" },
              }),
              _vm._v(" "),
              _c("themed-image", {
                attrs: {
                  src: "/content/images/static/why-gf/revenue-graph.svg",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.hexPloreIt.author,
              quote: _vm.quotes.hexPloreIt.text,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" },
            [
              _c(
                "box",
                [
                  _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-2" }, [
                    _vm._v("I am ready to try Gamefound"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    Create a free test campaign and see how Gamefound works — no commitment needed. Explore the\n                    features,\n                    build your page, and experience the full toolset before you go live. It’s the easiest way to get\n                    started.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "_mt-6",
                      attrs: {
                        tag: "a",
                        href: _vm.createCreatorAccountUrl,
                        theme: "accent",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Become a creator\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "box",
                [
                  _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-2" }, [
                    _vm._v("Not convinced yet?"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    Want to dig deeper before you decide? You can learn more about the platform,\n                    explore detailed data, and if you still have questions, feel free to reach out to us via our\n                    "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "_tc--accent",
                        attrs: { href: _vm.contactForCreatorsUrl },
                      },
                      [_vm._v("contact form")]
                    ),
                    _vm._v(".\n                "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "_mt-6",
                      attrs: {
                        tag: "a",
                        href: _vm.becomeACreatorUrl,
                        theme: "accent",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Learn more\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }